import { BasePortModel } from "./BasePortModel";
import { FailureArrowLinkModel } from "../link/FailureArrowLinkModel";

export class FailurePortModel extends BasePortModel {
	constructor (alignment, isIn) {
		super({
			type: "failure",
			name: alignment,
			alignment: alignment,
			in: isIn
		});
	}

	createLinkModel () {
		if (this.getOptions().in) {
			return null;
		}

		return new FailureArrowLinkModel();
	}

	canLinkToPort (port) {
		if (super.canLinkToPort(port)) {
			if (port instanceof FailurePortModel) {
				return true;
			}
		}

		return false;
	}
}
